





























import { Component, PropSync } from 'vue-property-decorator';
import {Action} from "vuex-class";
import BaseFilter from '@/components/Filter/BaseFilter';
import { OverdraftFilter } from '@/store/finance/types';
import {SelectWings} from "wings-ui-components";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings}})
export default class OverdraftsFilter extends BaseFilter<OverdraftFilter> {
  @PropSync('show') is_show!: boolean;
  @Action("getPartners") actionGetPartners: any;
  @Action("getOverdrafts") actionGetOverdrafts: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): OverdraftFilter {
    return {
      partner: undefined,
    }
  }

  params = {prepaid: true}
  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

 async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Balance",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetOverdrafts(this.filter)
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
